import React, { useEffect } from 'react'
import styled from 'styled-components'
//import PropTypes from 'prop-types'

const MediaWrap = styled.div`
  display: flex; /* 横並び */
  flex-wrap: wrap;
  box-shadow: 0 0 3px 2px 'rgba(0,0,0,0.4)';
  background-color: #fff;
  color: #fff;
  font-size: 1.5vw;
  width: 100%;
  text-align: center;
  align-items: center;
  background-color: #649CDF;
`
const MediaItem = styled.div`
  display: flex; /* 縦並び */
  flex-direction: column;
  height: 40px;
  border-right: ${props => props.borderNone ? '': '1px solid #000'};
`

const ProgressTitle = styled.div`
  margin: auto;
  text-overflow: ellipsis; /* 見切れ対策 */
  overflow: hidden;
  white-space: nowrap;
` 

const MaterialHandlingHeader = (props) => {
  const {
  } = props

  // 初期値
  useEffect(() => {
  })

  return (
    <MediaWrap>
      <MediaItem>
        <ProgressTitle style={{width:'275px'}}></ProgressTitle>
      </MediaItem>
      <MediaItem>
        <ProgressTitle style={{width:'280px'}}>カゴ車</ProgressTitle>
      </MediaItem>
      <MediaItem>
        <ProgressTitle style={{width:'280px'}}>カートラ</ProgressTitle>
      </MediaItem>
      <MediaItem>
        <ProgressTitle style={{width:'280px'}}>保冷カーゴ車</ProgressTitle>
      </MediaItem>
      <MediaItem>
        <ProgressTitle style={{width:'280px'}}>ドーリー</ProgressTitle>
      </MediaItem>
      <MediaItem borderNone>
        <ProgressTitle style={{width:'280px'}}>たまごカゴ</ProgressTitle>
      </MediaItem>
    </MediaWrap>
  )
}

MaterialHandlingHeader.propTypes = {
}

export default MaterialHandlingHeader
